import { TONCONNECT_MANIFEST_URL } from '~/config';

/**
 * Mirrors the THEME enum of @tonconnect/ui. Kept here so that components can
 * name a colour scheme without a static import of the library — that single
 * import is enough to pull all of TonConnect into the bundle that needs it.
 */
export const THEME = Object.freeze({
    DARK: 'DARK',
    LIGHT: 'LIGHT',
});

let instance;
let instancePromise;

/**
 * Loads @tonconnect/ui and builds the single UI instance the app shares.
 * Repeated calls hand back the very same instance.
 *
 * @return {Promise<Object>}
 */
const loadTonConnect = function () {
    if (!instancePromise) {
        instancePromise = import(/* webpackChunkName: "tonconnect" */ '@tonconnect/ui')
            .then(({ TonConnectUI }) => {
                instance = new TonConnectUI({
                    manifestUrl: TONCONNECT_MANIFEST_URL,
                });

                return instance;
            })
            .catch((error) => {
                // Don't cache the failure, let the next click try again:
                instancePromise = undefined;
                throw error;
            });
    }

    return instancePromise;
};

export default {
    install(Vue) {
        // Synchronous accessor: the instance once it exists, undefined before
        // that. Components that only ever render for a connected wallet can
        // read it directly.
        Object.defineProperty(Vue.prototype, '$tonConnect', {
            get: () => instance,
        });

        // Asynchronous accessor: loads the library on the first call.
        Vue.prototype.$tonConnectReady = loadTonConnect; // eslint-disable-line no-param-reassign
    },
};
